module.exports = __webpack_public_path__ + "media/images/kids6-a79d2b0b33e757a5271a2a28f39ed76a.jpg";